import {NgModule} from '@angular/core';

import {FeatureActiveDirective} from './directive/feature-active';
import {FeaturesService} from './services/features-service';

@NgModule({
  declarations: [FeatureActiveDirective],
  providers: [FeaturesService],
  exports: [FeatureActiveDirective],
})
export class FeatureModule {}
